import React from 'react'
import { Image } from '@sitecore-jss/sitecore-jss-react'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { withTranslation } from 'react-i18next'

const aw_common_gallery_inset = (props) => <Image field={props.fields?.Image} />

export default withSitecoreContext()(withTranslation()(aw_common_gallery_inset))
